export default {
  common: {
    app_base_url: window.app_base_url || null
  },

  projectModal: {
    selector: "#project-select"
  }
};
